const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const monthKey = (it) => (it.taken_at_local || "").slice(0, 7);

export const monthLabel = (key) => {
  const [y, m] = key.split("-");
  return m ? `${MONTHS[Number(m) - 1]} ${y}` : "Undated";
};

export const hoverLabel = (it) => {
  const loc = it.location || {};
  const place = loc.city && loc.city !== "Unknown" ? `${loc.city}, ${loc.country_code || loc.country}` : null;
  const year = !it.date_unknown && it.taken_at_local ? it.taken_at_local.slice(0, 4) : null;
  return [place, year].filter(Boolean).join(" · ");
};

export const groupByMonth = (items) => {
  const groups = [];
  for (const it of items) {
    const key = monthKey(it);
    const last = groups[groups.length - 1];
    if (last && last.key === key) last.items.push(it);
    else groups.push({ key, label: monthLabel(key), items: [it] });
  }
  return groups;
};

export const otherSpace = (space) => (space === "family" ? "private" : "family");
const SPACE_NAMES = { private: "My Library (Private)", family: "Family", guest: "Family & Guests", admin: "Admin" };
export const spaceName = (space) => SPACE_NAMES[space] || "their library";
// Guest visibility = shared with both (Family already sees Guest)
export const destinations = () => [["private", "My Library (Private)"], ["family", "Family"], ["guest", "Both (Family + Guests)"]];

export const friendlyDate = (local) => {
  if (!local) return "Date unknown";
  const [d, t = "00:00"] = local.split("T");
  const [y, m, day] = d.split("-").map(Number);
  const [hh, mm] = t.split(":").map(Number);
  const dt = new Date(y, m - 1, day, hh, mm);
  const date = dt.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  const time = dt.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  return `${date} · ${time}`;
};

export const fileSize = (b) => {
  if (b == null) return "–";
  if (b >= 1024 ** 3) return `${(b / 1024 ** 3).toFixed(1)} GB`;
  if (b >= 1024 ** 2) return `${(b / 1024 ** 2).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(b / 1024))} KB`;
};
